export default {
  'powerBiServer.title': 'Manage Power BI Servers',
  'powerBiServer.isPremium': 'Premium',
  'powerBiServer.authorityUrl': 'Authority URL',
  'powerBiServer.resourceUrl': 'Resource URL',
  'powerBiServer.apiUrl': 'API URL',
  'powerBiServer.embedUrlBase': 'Embed URL base',
  'powerBiServer.redirectUrl': 'Redirect URL',
  'powerBiServer.username': 'Username',
  'powerBiServer.clientId': 'Client ID',
  'powerBiServer.clientSecret': 'Client secret',
};
